import { assertEvent, assign } from 'xstate5';

import { type BundleMachineAction, type SelectedProduct } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Notes the default ingredients a selected product will be added without.
 */
export const storeOutOfStockIngredients: BundleMachineAction = assign((args) => {
  const { context, event } = args;

  assertEvent(event, 'customization.out-of-stock-ingredients-found');

  const { actorId: selectionId, ingredientNames } = event;

  return {
    selectedProducts: context.selectedProducts.map((selectedProduct) =>
      markOutOfStockIngredients({ selectedProduct, selectionId, ingredientNames }),
    ),
  };
});

// ─── Helpers ─────────────────────────────────────────────────────────────────

function markOutOfStockIngredients(params: MarkOutOfStockIngredientsParams): SelectedProduct {
  const { selectedProduct, selectionId, ingredientNames } = params;

  if (selectedProduct.selectionId !== selectionId) return selectedProduct;

  return { ...selectedProduct, outOfStockIngredientNames: ingredientNames };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type MarkOutOfStockIngredientsParams = {
  selectedProduct: SelectedProduct;
  selectionId: string;
  ingredientNames: string;
};
